
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiWarningRectifiedOutlined as ObiWarningRectifiedOutlinedElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-warning-rectified-outlined.js';
 
 
 

 
 export const ObiWarningRectifiedOutlined = createComponent({
   react: React,
   tagName: 'obi-warning-rectified-outlined',
   elementClass: ObiWarningRectifiedOutlinedElement,
   events: {
     
   }
  });
 
 